import { EboEmployeeEvent } from '../../base-classes/ebo-employee-event';

export class DisputeJournal extends EboEmployeeEvent {
  description: string;

  constructor(jsonData?: Partial<DisputeJournal>) {
    super(jsonData);
  }
}
